import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getConfigMinDateFailed,
  getConfigMinDateStart,
  getConfigMinDateSuccess,
  updateConfigMinDate,
  updateDefaultStartDate,
} from "../redux/getConfigMinDate";
import { getConfigMinDateAPI } from "core/http/service/timeKeeping";
import moment from "moment";
import { setMonthYearListArriveLate } from "../redux/getListArriveLate";
import { setMonthYearListRequestLeave } from "../redux/getListRequestLeave";
import { setMonthYearListFeedbackManager } from "../redux/getListFeedbackManager";
import { setMonthYearListFeedback } from "../redux/getListFeedback";
import { setMonthYearListArriveLateManager } from "../redux/getListArriveLateManager";
import { setMonthYearListRequestLeaveManager } from "../redux/getListRequestLeaveManager";
import { formFilterEmployeeLeaveUpdate } from "../redux/formFilterEmployeeLeave";

function* getConfigMinDateWork() {
  try {
    const res = yield call(getConfigMinDateAPI);

    yield put({
      type: getConfigMinDateSuccess.type,
      payload: res,
    });

    // kiểm tra ngày bắt đầu của kì công tiếp theo
    if (res?.checkInStartDay) {
      let dateNow = moment();
      if (dateNow.get("date") >= res?.checkInStartDay) {
        dateNow = dateNow.add(1, "month");
      }
      // ngày bắt đầu của kì công tiếp theo sẽ thay đổi nếu thay đổi tháng ở bảng công
      yield put({ type: updateConfigMinDate.type, payload: dateNow });

      // ngày bắt đầu của kì công tiếp theo sẽ là ngày đầu tiên của tháng mặc định
      yield put({ type: updateDefaultStartDate.type, payload: dateNow });

      yield put({
        type: formFilterEmployeeLeaveUpdate.type,
        payload: {
          from: dateNow.clone().subtract(1, "month"),
          to: dateNow,
        },
      });

      const timeSelected = {
        month: dateNow.month() + 1,
        year: dateNow.year(),
      };

      // cập nhật lại tháng năm của các bảng
      yield put({
        type: setMonthYearListArriveLate.type,
        payload: timeSelected,
      });

      yield put({
        type: setMonthYearListRequestLeave.type,
        payload: timeSelected,
      });

      yield put({
        type: setMonthYearListArriveLateManager.type,
        payload: timeSelected,
      });

      yield put({
        type: setMonthYearListRequestLeaveManager.type,
        payload: timeSelected,
      });

      yield put({
        type: setMonthYearListFeedbackManager.type,
        payload: timeSelected,
      });

      yield put({
        type: setMonthYearListFeedback.type,
        payload: timeSelected,
      });
    }
  } catch (error: any) {
    yield put({
      type: getConfigMinDateFailed.type,
    });
  }
}

function* watchGetConfigMinDate() {
  yield takeLatest(getConfigMinDateStart.type, getConfigMinDateWork);
}

export default function* getConfigMinDateSaga() {
  yield all([watchGetConfigMinDate()]);
}
